if (!customElements.get('seed-image-gallery')) {
  customElements.define('seed-image-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.seed-gallery__track');
      this.slides = [...this.querySelectorAll('.seed-gallery__slide')];
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.status = this.querySelector('[data-gallery-status]');
      this.currentIndex = 0;
      if (!this.track || this.slides.length < 2) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index), { signal });
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (!this.track.clientWidth) return;
          const index = Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth);
          this.updateIndex(Math.max(0, Math.min(index, this.slides.length - 1)));
        });
      }, { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let destination = this.currentIndex;
        if (event.key === 'ArrowRight') destination += rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') destination += rtl ? 1 : -1;
        else if (event.key === 'Home') destination = 0;
        else if (event.key === 'End') destination = this.slides.length - 1;
        else return;
        event.preventDefault();
        this.goTo(destination);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => {
        this.goTo(this.currentIndex, false);
      });
      this.resizeObserver.observe(this.track);
    }

    goTo(index, animate = true) {
      
      const destination = Math.max(0, Math.min(index, this.slides.length - 1));
      const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: direction * destination * this.track.clientWidth,
        behavior: animate && !reducedMotion ? 'smooth' : 'auto'
      });
    }

    updateIndex(index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;
      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.status) this.status.textContent = this.slides[index].getAttribute('aria-label');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.controller = null;
    }
  });
}

